import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const Users = () => {

    const { apipath, logout, goBack, filepath } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [isLoading, setIsLoading] = useState(false);
    const [organizationData, setorganizationData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState('');

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        console.log(filters);
        let filteredItems = [...organizationData];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);


    const getorganizations = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/organizations',
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            setorganizationData(response.data.organizations);
            setFilteredData(response.data.organizations);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getorganizations();
    }, []);

    const deleteUser = async (uid) => {
        const id = uid;
        // Display a confirmation prompt
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/delete_user', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getorganizations();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const confirmDeletion = (uid) => {
        iziToast.show({
            color: 'red',
            message: 'Confirm Deletion',
            position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
            buttons: [
                [
                    '<button>Ok</button>',
                    function (instance, toast) {
                        deleteUser(uid);
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ],
                [
                    '<button>Close</button>',
                    function (instance, toast) {
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ]
            ]
        });
    }

    const userStatus = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/user_status', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getorganizations();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            // setIsLoading(false);
        }
    }
    const editUser = (uid) => {
        localStorage.setItem('editUser', uid);
        navigate('/edit_organization');

    }

    const exportOrganizations = async () => {
        // console.log("export clicked");
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/export_organizations', {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    responseType: 'blob',
                }
            );
            // console.log(response.data);
            // Create a new Blob object for the file
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'organizations.xlsx'); // Specify the file name
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);

            // if (response.data.status === "false") {
            //     iziToast.error({
            //         message: response.data.message,
            //         position: "topCenter"
            //     });
            // }
            // else{
            //     iziToast.success({
            //         message: response.data.message,
            //         position: "topCenter"
            //     });
            // }

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const [activeTab, setActiveTab] = useState("Organization");

    const [searchText, setSearchText] = useState("");

    const importUsers = async (e) => {
        const file = document.getElementById('importFile').files[0];
        // console.log(file);
        if (file) {
            // console.log('importing users');
            const formdata = new FormData();
            formdata.append('file', file);
            setIsLoading(true);
            try {
                const response = await axios.post(
                    apipath + '/import_users', formdata,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + token
                        },
                    }
                );
                document.getElementById('importFile').value = "";
                // console.log(response.data);
                if (response.data.status === 'true') {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                }
                if (response.data.status === 'unauthentic') {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                getorganizations();

            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
                document.getElementById('importFile').value = "";

            } finally {
                document.getElementById('importFile').value = "";
                setIsLoading(false);
            }
        }
    }
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleString("sv-SE", { 
            year: "numeric", 
            month: "2-digit", 
            day: "2-digit", 
            hour: "2-digit", 
            minute: "2-digit",
            hour12: false 
        }).replace(" ", " ");
    };

    // Define columns for the table
    const columns = [
        { name: "ID", selector: (row) => row.id, sortable: true, },
        { name: "Name", selector: (row) => row.name, sortable: true, },
        { name: "Email", selector: (row) => row.email, sortable: true, },
        { name: "Phone", selector: (row) => row.phone, sortable: true, },
        { name: "City", selector: (row) => row.city, sortable: true, },
        { name: "State", selector: (row) => row.state, sortable: true, },
        { name: "Pincode", selector: (row) => row.pincode, sortable: true, },
        { name: "Reg. On", selector: (row) => formatDate(row.created_at), sortable: true, width:"200px" },
        {
            name: "Status", selector: (row) => <>
                <input type="checkbox" onClick={() => userStatus(row.id)} checked={(row.status === 'true')} title={(row.status === "true") ? 'Active' : 'In-Active'} />
            </>, sortable: true,
        },
        {
            name: "Action", selector: (row) => <>
                <i class="fa fa-edit rounded p-1 cursor-pointer text-blue-600 hover:text-white hover:bg-blue-600 border-2 border-blue-600" onClick={() => editUser(row.id)}></i>
                <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white hover:bg-red-600 border-2 border-red-600" onClick={() => confirmDeletion(row.id)}></i>
            </>, sortable: true,
        },
    ];

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"users"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8 flex-grow">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between align-middle shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                                <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>
                                Organizations
                            </span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/users`}><span class={`md:ml-5 ml-2 ${activeTab === 'Organization' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Organizations
                                </span></Link>
                                <Link to={`/students`}><span class={`md:ml-5 ml-2 ${activeTab === 'Student' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Students
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-cyan-900 to-cyan-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Organizations</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    onChange={handleFilterChange}
                                    className="p-1.5 border shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]"
                                />
                                <div>
                                    <Link to={`/add_organization`}><button className="p-1 text-sm font-bold text-teal-800 rounded-lg border-2 border-teal-800 hover:bg-teal-800 hover:text-white hover:border-transparent">
                                        + Add
                                    </button></Link>
                                    <button onClick={() => document.getElementById('importFile').click()} className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent">
                                        Import
                                    </button>
                                                            <Link to={`${filepath}/public/organization_import_sample.xlsx`} download={`organization_import_sample.xlsx`} title="download excel sample file" target="_blank" className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent"><i className="fa fa-download"></i> Sample</Link>
                                    <button onClick={() => exportOrganizations()} className="p-1 ms-3 text-sm font-bold text-orange-500 rounded-lg border-2 border-orange-500 hover:bg-orange-500 hover:text-white hover:border-transparent">
                                        Export
                                    </button>
                                </div>
                            </div>

                            <div style={{ "display": "none" }}><input type="file" id="importFile" onChange={(e) => importUsers()} /></div>
                            <div className="max-h-[70vh] overflow-auto shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]">

                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};